import PropTypes from 'prop-types';
// @mui
import { Box, Card, Link, Typography, Stack } from '@mui/material';
import { useState, useEffect } from 'react';
import { styled } from '@mui/material/styles';
// components
import Label from '../components/label';
import { ColorPreview } from '../components/color-utils';

// ----------------------------------------------------------------------

const StyledProductImg = styled('img')({
  top: 0,
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  position: 'absolute',
});

// ----------------------------------------------------------------------

export default function HuntingClubMapa(props) {
  // const { naziv, mjesto, adresa, telefon, predsjednik, sekretar, karta } = huntingclub;
  
  useEffect(() => {
		console.log(props.huntingclub);
		console.log(props.huntingclub.naziv);
  });


  return (
    <Card>
      <Box sx={{ pt: '100%', position: 'relative' }}>
        <StyledProductImg alt={props.huntingclub.naziv} src={props.huntingclub.karta} />
      </Box>

      <Stack spacing={2} sx={{ p: 3 }}>
        <Link color="inherit" underline="hover">
          <Typography align="center" variant="subtitle3" noWrap>
            {props.huntingclub.naziv}
          </Typography>
        </Link>

        <Stack direction="column" alignItems="left" justifyContent="space-between">
		  <Typography variant="subtitle2" noWrap>
            Mjesto: {props.huntingclub.mjesto}
          </Typography>
		  
		  <Typography variant="subtitle2" noWrap>
            Predsjednik: {props.huntingclub.predsjednik}
          </Typography>
		  
		  <Typography variant="subtitle2" noWrap>
            Lovovođa: {props.huntingclub.lovovodja}
          </Typography>
		  
		  <Typography variant="subtitle2" noWrap>
            Kinološki referent: {props.huntingclub.kinoloskireferent}
          </Typography>
		  
        </Stack>
      </Stack>
    </Card>
  );
}
